import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';

import { FieldPageLayout } from 'src/app/graph/insights/fieldPage/FieldPageLayout';
import { fieldRouteConfig } from 'src/app/graph/routes';
import { DocumentTitle } from 'src/components/documentTitle/DocumentTitle';
import { useRouteParams } from 'src/hooks/useRouteParams';

import { FieldMainContent } from './FieldMainContent';

export const FieldPage = () => {
  const { insightsTab, typeName, fieldName } = useRouteParams(fieldRouteConfig);
  const location = useLocation();

  if (insightsTab === 'fields') {
    return (
      <Redirect
        to={fieldRouteConfig.locationFrom({
          location,
          patch: {
            insightsTab: 'objectFields',
          },
        })}
      />
    );
  }

  return (
    <>
      <DocumentTitle title={`${typeName}.${fieldName}`} />
      <FieldPageLayout>
        <FieldMainContent />
      </FieldPageLayout>
    </>
  );
};
